import { render, staticRenderFns } from "./TheGeneralCodeAddForm.vue?vue&type=template&id=8238820a&"
import script from "./TheGeneralCodeAddForm.vue?vue&type=script&lang=js&"
export * from "./TheGeneralCodeAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports